"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ModalChooseTreatment_vue_1 = __importDefault(require("../components/modals/ModalChooseTreatment.vue"));
const ModalSamplesList_vue_1 = __importDefault(require("./modals/ModalSamplesList.vue"));
const CardLocationModel_1 = __importDefault(require("../Abstract/models/CardLocationModel"));
const Treatment_1 = __importDefault(require("../Abstract/models/Treatment"));
const ModalConfirmAction_vue_1 = __importDefault(require("./modals/ModalConfirmAction.vue"));
let LocationCard = class LocationCard extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isDeployModalChooseTreatment = false;
        this.isDeployModalSamples = false;
        this.isDeployModalConfirmAction = false;
        this.currentTreatment = new Treatment_1.default({
            meta: {
                name: '',
                treatmentID: 0,
                control: false,
            },
            times: [],
        });
        this.CardLocationModel = new CardLocationModel_1.default(this.indexCard, this.indexLine, this.locations, this.elementsForLine);
    }
    updateAssignatedSamples(payload) {
        this.$emit('updateAssignatedSamples', payload);
    }
    dismissModalConfirmAction() {
        this.isDeployModalConfirmAction = false;
    }
    updateCurrentTreatment(treatment) {
        this.currentTreatment = treatment;
    }
    deployPanelDetailsLocation(location) {
        this.$emit('deployPanelDetailsLocation', location);
    }
    dismissModalChooseTreatment() {
        this.isDeployModalChooseTreatment = false;
    }
    dismissModalSamplesList() {
        this.isDeployModalSamples = false;
    }
    deployModalChooseTreatment(location) {
        this.deployPanelDetailsLocation(location);
        if (this.accent === 'info') {
            this.location.currentTime += 1;
            this.$emit('updateLocationTime', this.location);
        }
        this.isDeployModalSamples = false;
        this.isDeployModalChooseTreatment = true;
    }
    deployModalSamples() {
        this.isDeployModalSamples = true;
        this.isDeployModalChooseTreatment = false;
    }
    get progress() {
        return this.location.timeProgress;
    }
    get samplesAssignedForTime() {
        return this.location.time_details[this.location.currentTime || 0].samplesAssigned;
    }
    get samplesTotalThisTime() {
        return this.location.time_details[this.location.currentTime || 0].samplesTotalThisTime;
    }
    get name() {
        return this.CardLocationModel.collectName;
    }
    get accent() {
        return this.location.accent;
    }
    get textAction() {
        return this.CardLocationModel.collectTitleActionAssign;
    }
    get ctaText() {
        return this.location.ctaText;
    }
    get currentMissingSamples() {
        return this.currentTreatment.times[this.location.currentTime].samplesTotalThisTime - this.currentTreatment.times[this.location.currentTime].samplesAssignedForTime;
    }
    get isCompleted() {
        return this.location.isCompleted;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], LocationCard.prototype, "indexCard", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], LocationCard.prototype, "indexLine", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], LocationCard.prototype, "elementsForLine", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], LocationCard.prototype, "cropName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], LocationCard.prototype, "isCardOpenDetails", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], LocationCard.prototype, "params", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], LocationCard.prototype, "location", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], LocationCard.prototype, "locations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], LocationCard.prototype, "samples", void 0);
LocationCard = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            CircleProgress: bmk_ui_framework_1.CircleProgress,
            CheckAloneIcon: bmk_ui_framework_1.CheckAloneIcon,
            ModalChooseTreatment: ModalChooseTreatment_vue_1.default,
            ModalSamplesList: ModalSamplesList_vue_1.default,
            ModalConfirmAction: ModalConfirmAction_vue_1.default,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
        },
    })
], LocationCard);
exports.default = LocationCard;
